import React, { useState, useEffect, Fragment } from 'react';
import { Row, Card, CardBody } from 'reactstrap';
import Select from 'react-select';
import { Colxx, Separator } from '../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  getGroupID,
  getSelectedGroup,
  setSelectedGroup,
  getUserID,
} from '../../../../../helpers/AxiosAPI';
import {
  gAPI_Internal_Property_List,
  gAPI_CheckUser_Property,
} from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CreatePropertyForm from './components/forms/CreatePropertyForm';
import UpdatePropertyForm from './components/forms/UpdatePropertyForm';
import { gAPI_Groups } from '../../../../../constants/APIs';
import { reactSelectOptionDiffrentProWithKeyValue, sortPropertyListByName } from '../../../../../helpers/Utils';


function Index({ propertyId, history }) {
  const [propertiesList, setPropertiesList] = useState([]);
  const [groupList, setGroupsList] = useState([]);
  const [groupId, setGroupId] = useState(getGroupID());
  const [SelectedValue, DropdownSelectedValue] = useState(getSelectedGroup());
  const [loading, setLoading] = useState(true);
  const [groupCurrency, setGroupCurrency] = useState("");

  useEffect(() => {
    const group = getSelectedGroup();
    if (group) {
      DropdownSelectedValue(group);
    }
    fetchProperties();
  }, [propertyId]);

  const fetchProperties = () => {
    setLoading(true);
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_CheckUser_Property}/${getUserID()}`,
    })
      .then((res) => {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Groups}`,
        })
          .then((res) => {
            setLoading(false);
            setGroupsList(res.data);
            getGroupCurrenct(res.data);
          })
          .catch((err) => console.log('err', err));
        if (typeof groupId === 'object' || SelectedValue) {
          const selectedGroupId = SelectedValue.value || groupId;
          setGroupId(selectedGroupId);
          setLoading(true);
          AxiosAPI({
            methhod: 'get',
            url: `${gAPI_Internal_Property_List}?group_id=${selectedGroupId}`,
          })
            .then((res) => {
              setPropertiesList(res.data);
              setLoading(false);
            })
            .catch((err) => console.log('err', err));
        }
      })
      .catch((err) => history.push('/app/error'));
  };

  const getGroupCurrenct = (list) => {
    if (SelectedValue !== undefined && SelectedValue !== null) {
      var currency = "";
      list.length > 0 && list.filter(l => l.groupId === SelectedValue.value).map(k => currency = k.currency);
      setGroupCurrency(currency);
    }
  }

  if (loading) {
    return (
      <Card className="d-flex flex-row mb-3">
        <CardBody>
          <h4 style={{ textAlign: 'center' }}>Loading...</h4>
        </CardBody>
      </Card>
    );
  }

  const handleChange = (e) => {
    setLoading(true);
    DropdownSelectedValue(e);
    setSelectedGroup(e);
    setGroupId(e.value);
    getGroupCurrenct(groupList);
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_List}?group_id=${e.value}`,
    })
      .then((res) => {
        setPropertiesList(res.data);
        setLoading(false);
      })
      .catch((err) => console.log('err', err));
  };
  return (
    <Fragment>
      <Row>

        <Colxx xxs="12" md="4" className="mb-4">
          <Select
            className="react-select"
            classNamePrefix="react-select"
            name="groupId"
            value={SelectedValue}
            onChange={handleChange}
            options={
              groupList
                ? reactSelectOptionDiffrentProWithKeyValue(
                  groupList,
                  true,
                  'groupId',
                  'name',
                  'Select Group'
                )
                : []
            }
          />
        </Colxx>
        <CreatePropertyForm groupId={groupId} groupCurrency={groupCurrency} />
        <Colxx xxs="12" md="8" className="mb-4">
          <div className="align-vertical-center">
            <b>
              {SelectedValue &&
                SelectedValue.label &&
                SelectedValue.value &&
                SelectedValue.label + ' (' + SelectedValue.value + ')'}
            </b>
          </div>
        </Colxx>
      </Row>

      <Separator className="mb-5 " />
      <Row>
        {sortPropertyListByName(propertiesList).map((property, index) => (
          <Colxx xxs="12" key={index}>
            <Card className="d-flex flex-row mb-3">
              <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                  <p className="mb-1  text-small w-15 w-sm-100">
                    <b>{property.name}</b>
                  </p>
                  <p className="mb-1 text-muted text-small w-15 w-sm-100">
                    {property.type}
                  </p>
                  <p className="mb-1 text-muted text-small w-50 w-sm-100">
                    {property.id}
                  </p>
                  <p className="mb-1 text-muted text-small w-20 w-sm-100">
                    {property.inventoryProvider}
                  </p>
                  <div className="w-20 w-sm-100">
                    <UpdatePropertyForm
                      id={property.id}
                      gptTemplate={property.gptPromptTemplates}
                      groupId={groupId}
                      fetchProperties={fetchProperties}
                      groupCurrency={groupCurrency}
                    />
                  </div>
                </div>
              </div>
            </Card>
          </Colxx>
        ))}
      </Row>

    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
